export default "__VITE_ASSET__B$guVMkF__"